import { IAmericanoLeaderboardRow } from "../../models/IAmericano";
import { TableWrap } from "../../ui/Table";
import "../StandingsTable/styles.scss";

type LeaderboardTableProps = {
  rows: IAmericanoLeaderboardRow[];
  /** "Player" when the stage's unitSize === 1, otherwise "Team" */
  unitLabel: "Player" | "Team";
};

const LeaderboardTable = ({ rows, unitLabel }: LeaderboardTableProps) => {
  return (
    <TableWrap className="standings-table-container leaderboard-table-container">
      <table className="ui-table standings-table leaderboard-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{unitLabel}</th>
            <th>MP</th>
            <th>W</th>
            <th>+/-</th>
            <th>Pts</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.teamId}>
              {/* Medals follow the rank (ties share one) */}
              <td className={row.rank <= 3 ? `standings-table__medal standings-table__medal--${row.rank}` : undefined}>
                {row.rank}
              </td>
              <td>{row.teamName}</td>
              <td>{row.played}</td>
              <td>{row.wins}</td>
              <td>{row.pointDifference > 0 ? `+${row.pointDifference}` : row.pointDifference}</td>
              <td>{row.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableWrap>
  );
};

export default LeaderboardTable;
